(function (root, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.WncColorGallery = api;
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';

  const normalize = value => String(value == null ? '' : value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
  const mediaId = value => value === null || value === undefined ? '' : String(value).split('/').pop();
  const contains = (text, color) => new RegExp('(^|[^a-z0-9])' + color.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '($|[^a-z0-9])').test(text);
  const foreignNames = ['Bege', 'Verde', 'Amarelo', 'Rosa', 'Roxo', 'Laranja', 'Vermelho', 'Azul', 'Branco', 'Preto', 'Marrom', 'Cinza', 'Off White', 'Bordô', 'Vinho'];

  function colorsInText(value, colors, compact) {
    const source = normalize(value);
    const compactSource = source.replace(/[^a-z0-9]/g, '');
    const names = colors.map(color => normalize(color));
    const matches = colors.filter(color => {
      const name = normalize(color);
      if (!name) return false;
      const aliases = [name, name.replace(/\b(preto|branco|vermelho|amarelo|roxo|cinzento|estonado)\b/g, word => word.slice(0, -1) + 'a')];
      if (name === 'bordo' && !names.includes('vinho')) aliases.push('vinho');
      if (name === 'vinho' && !names.includes('bordo')) aliases.push('bordo');
      return aliases.some(alias => contains(source, alias) || compact && compactSource.includes(alias.replace(/[^a-z0-9]/g, '')));
    });
    return matches.filter(color => !matches.some(longer => normalize(longer).length > normalize(color).length && contains(normalize(longer), normalize(color))));
  }

  function metadataOwners(item, names, blockedColors) {
    const alt = colorsInText(item.alt, names);
    let filename = String(item.src || '').split(/[?#]/)[0].split('/').pop() || '';
    try { filename = decodeURIComponent(filename); } catch (_) {}
    const filenameColors = colorsInText(filename, names, true);
    const hasForeignAlt = !alt.length && colorsInText(item.alt, blockedColors).length > 0;
    const direct = hasForeignAlt ? [] : alt.length ? alt : filenameColors;
    const foreign = hasForeignAlt || !direct.length && colorsInText(filename, blockedColors, true).length > 0;
    return direct.length || foreign ? new Set(direct) : null;
  }

  function buildGroups(config) {
    config = config && typeof config === 'object' ? config : {};
    const colorEntries = Array.isArray(config.colors) ? config.colors : [];
    const canonical = new Map();
    for (const entry of colorEntries) {
      const name = typeof entry === 'string' ? entry : entry && entry.name;
      const key = normalize(name);
      if (key && !canonical.has(key)) canonical.set(key, { name: String(name), anchors: [] });
      if (key && Array.isArray(entry && entry.anchors)) canonical.get(key).anchors.push(...entry.anchors);
    }
    const groups = new Map(Array.from(canonical.values(), color => [color.name, new Set()]));
    if (!groups.size || !Array.isArray(config.media)) return groups;
    const rawMedia = config.media;
    const catalog = new Map();
    const media = rawMedia.map((item, index) => ({ ...item, id: mediaId(item && item.id), inputIndex: index })).filter(item => {
      if (!item.id || catalog.has(item.id)) return false;
      catalog.set(item.id, item);
      return true;
    }).sort((left, right) => Number(left.position) - Number(right.position) || left.inputIndex - right.inputIndex);
    const canInherit = config.complete === true && media.length === rawMedia.length && media.every((item, index) => Number(item.position) === index + 1);
    const curated = config.mode === 'curated';
    const names = Array.from(groups.keys());
    const blockedColors = foreignNames.filter(color => !colorsInText(color, names).length && !names.some(name => colorsInText(name, [color]).length));
    const anchors = new Map();
    const currentAnchors = new Map(names.map(name => [name, new Set()]));
    for (const color of canonical.values()) {
      for (const value of color.anchors) {
        const id = mediaId(value);
        if (!catalog.has(id)) continue;
        if (!anchors.has(id)) anchors.set(id, new Set());
        anchors.get(id).add(color.name);
        currentAnchors.get(color.name).add(id);
      }
    }
    const map = config.override && typeof config.override === 'object' && !Array.isArray(config.override) ? config.override : {};
    const rawGroups = new Map();
    const ownership = new Map();
    const shared = new Set();
    for (const [key, ids] of Object.entries(map)) {
      if (!Array.isArray(ids)) continue;
      if (key === '*') {
        ids.map(mediaId).filter(id => catalog.has(id)).forEach(id => shared.add(id));
        continue;
      }
      const color = canonical.get(normalize(key));
      if (!color) continue;
      if (!rawGroups.has(color.name)) rawGroups.set(color.name, []);
      rawGroups.get(color.name).push(...ids.map(mediaId));
      for (const id of ids.map(mediaId).filter(id => catalog.has(id))) {
        if (!ownership.has(id)) ownership.set(id, new Set());
        ownership.get(id).add(color.name);
      }
    }
    // A photographed item sometimes has a shared native binding across two colors.
    // Only an existing unique curated owner may disambiguate that old binding.
    for (const [id, native] of anchors) {
      const approved = ownership.get(id);
      if (curated && native.size > 1 && approved && approved.size === 1 && native.has(approved.values().next().value)) anchors.set(id, new Set(approved));
    }
    const explicit = new Map(media.map(item => [item.id, metadataOwners(item, names, blockedColors)]));
    const additions = new Set();
    for (const item of media) {
      const owners = explicit.get(item.id);
      if (!anchors.has(item.id) && !ownership.has(item.id) && !shared.has(item.id) && owners && owners.size === 1) additions.add(owners.values().next().value);
    }
    const recovery = new Set();
    const intentionalEmptyGroups = new Set();
    for (const name of names) {
      const raw = rawGroups.get(name);
      const native = new Set([...currentAnchors.get(name)].filter(id => anchors.get(id).size === 1 && anchors.get(id).has(name)));
      // An intentional empty group stays empty until a current native anchor identifies new photography.
      const intentionalEmpty = raw && raw.length === 0 && native.size === 0;
      if (intentionalEmpty) intentionalEmptyGroups.add(name);
      const healthy = raw && raw.length > 0 && raw.every(id => catalog.has(id) && (!anchors.has(id) || anchors.get(id).size === 1 && anchors.get(id).has(name))) && [...native].every(id => raw.includes(id));
      // A legacy one-image entry is only an anchor, not a closed photographic selection.
      // New explicit same-color photos validate that anchor's current native run.
      const anchorOnlyExpansion = healthy && new Set(raw).size === 1 && native.has(raw[0]) && additions.has(name);
      if (!curated || !intentionalEmpty && (!healthy || anchorOnlyExpansion)) recovery.add(name);
    }
    let currentColor = names.length === 1 && !curated && canInherit ? names[0] : null;
    for (const item of media) {
      const id = item.id;
      if (shared.has(id)) {
        groups.forEach(group => group.add(id));
        continue;
      }
      let owners = anchors.get(id);
      let origin = owners ? 'anchor' : null;
      if (!owners && ownership.has(id)) {
        owners = ownership.get(id);
        origin = 'override';
      }
      if (!owners) {
        const metadata = explicit.get(id);
        if (metadata) {
          owners = metadata;
          origin = 'metadata';
        }
      }
      if (owners) {
        currentColor = owners.size === 1 ? owners.values().next().value : null;
        if (currentColor && (origin !== 'metadata' || !intentionalEmptyGroups.has(currentColor))) groups.get(currentColor).add(id);
      } else if (canInherit && currentColor && recovery.has(currentColor)) {
        groups.get(currentColor).add(id);
      }
    }
    return groups;
  }

  return Object.freeze({ buildGroups });
});
